<aside class="ui-menu-sidebar">
  <nav [attr.aria-label]="ariaLabel()">
    <ul class="ui-menu-sidebar__list" role="menubar" aria-orientation="vertical">
      @for (item of items(); track item.value) {
        @if (item.sectionTitle) {
          <li class="ui-menu-sidebar__section-title" role="presentation">
            {{ item.sectionTitle }}
          </li>
        }
        <li class="ui-menu-sidebar__li" role="none">
          <button
            type="button"
            class="ui-menu-sidebar__item"
            role="menuitem"
            [class.ui-menu-sidebar__item--active]="item.value === selectedValue()"
            [disabled]="item.disabled ?? false"
            (click)="onItemClick(item)"
          >
            <span class="ui-menu-sidebar__label">{{ item.label }}</span>
          </button>
        </li>
      }
    </ul>
  </nav>
</aside>
